<template>
  <section>
    <gs-header title="Quản lý địa chỉ">
      <!-- <router-link :to="{name: 'create-address'}" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm mới</router-link> -->
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="addressTable" :table-name="addressTable" data-source="addresses" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-select v-model="filters.city_id" filterable placeholder="Chọn tỉnh thành" @change="getDistricts"
                class="width-100">
                <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select :disabled="!filters.city_id" v-model="filters.district_id" filterable
                placeholder="Chọn quận huyện" @change="getWards" class="width-100">
                <el-option v-for="district in districts" :key="district.id" :label="district.name" :value="district.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select :disabled="!filters.district_id" v-model="filters.ward_id" filterable
                placeholder="Chọn phường xã" @change="filter" class="width-100">
                <el-option v-for="ward in wards" :key="ward.id" :label="ward.name" :value="ward.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select class="display-block" v-model="suggettionClient" filterable remote
                placeholder="Tên, sdt, .... khách hàng" :remote-method="selectClient" :loading="fetchClient"
                @change="selectSuggettionClient">
                <el-option v-for="(item, index) in listClient" :key="index" :value="item">
                  <span class="pull-left text-gray"><i class="fa fa-user"></i>&nbsp;{{ item.name }}</span>
                  <span class="pull-right text-gray"><i class="fa fa-mobile"></i>&nbsp;{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </section>
        <section slot="inline-filters">
          <div class="text-middle" v-if="filters.client_id">
            <a @click.prevent="removeClient" class="ui teal tag label">{{ client.name }}</a>
          </div>
          <div v-else>
            &nbsp;
          </div>
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border :row-class-name="tableRowClassName" style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[addressTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[addressTable].current_page - 1) * dataPaginations[addressTable].per_page)}}</small>
              </template>
            </el-table-column>

            <el-table-column label="Địa chỉ">
              <template slot-scope="scope">
                <p>{{ scope.row.street }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Phường xã">
              <template slot-scope="scope">
                <p v-if="scope.row.ward">{{ scope.row.ward.data.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Quận huyện">
              <template slot-scope="scope">
                <p v-if="scope.row.district">{{ scope.row.district.data.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Tỉnh thành">
              <template slot-scope="scope">
                <p v-if="scope.row.city">{{ scope.row.city.data.name }}</p>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <!-- <el-tooltip placement="top" content="Chi tiết" class="display-inline" v-if="!scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click.prevent="detailAddress(scope.row)"><i class="fa fa-search"></i></a>
                  </el-tooltip> -->
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-address', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <!-- <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.deleted_at">
                     <a @click.prevent="deleteAddress(scope.row)" class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Khôi phục" class="display-inline" v-if="scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click="restore(scope.row)"><i class="fa fa-refresh" aria-hidden="true"></i></a>
                  </el-tooltip> -->
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce, keys, forEach } from 'lodash'
import ls from 'local-storage'
import { deleteAddress, restoreAddress } from 'src/api/address'
import { getAllClients } from 'src/api/clients'
export default {
  name: 'Address',
  data() {
    return {
      addressTable: 'addresses',
      filters: {
        sort: 'created_at:-1',
        city_id: undefined,
        district_id: undefined,
        ward_id: undefined,
        client_id: undefined,
        include: 'city,district,ward'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      suggettionClient: {},
      fetchClient: false,
      listClient: []
    }
  },
  computed: {
    ...mapGetters('city', ['cities']),
    ...mapGetters('district', ['districts']),
    ...mapGetters('ward', ['wards']),
    ...mapGetters('address', ['address']),
    ...mapGetters('client', ['client'])
  },
  methods: {
    ...mapActions('city', ['getAllCity']),
    ...mapActions('district', ['getDistrictByCityId']),
    ...mapActions('ward', ['getWardByDistrictId']),
    ...mapActions('address', ['getAddress', 'setAddress']),
    ...mapActions('client', ['setClient']),
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.addressTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.addressTable)
      }
    }, 300),
    removeFilter() {
      if (!this.checkDefaultFilter({
        sort: 'created_at:-1',
        city_id: undefined,
        district_id: undefined,
        ward_id: undefined,
        client_id: undefined,
        include: 'city,district,ward'
      })) {
        this.reloadGsTable(this.addressTable)
      }
      this.removeClient()
      this.filters = {
        sort: 'created_at:-1',
        city_id: undefined,
        district_id: undefined,
        ward_id: undefined,
        client_id: undefined,
        include: 'city,district,ward'
      }
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    deleteAddress(address) {
      this.setAddress(address)
      this.$confirm(`Bạn chắc chắn muốn xóa địa chỉ ${this.address.name}`, 'Xóa địa chỉ', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delAddress()
      }).catch(() => {

      })
    },
    delAddress() {
      deleteAddress(this.address.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa địa chỉ thành công'
          })
          this.reloadGsTable(this.addressTable)
        } else {
          this.$message({
            type: 'danger',
            message: 'Xóa địa chỉ thất bại'
          })
        }
      })
    },
    tableRowClassName(row) {
      if (row.deleted_at) {
        return 'row-orange'
      }
      return null
    },
    restore(address) {
      this.setAddress(address)
      this.$confirm(`Bạn chắc chắn muốn khôi phục địa chỉ ${this.address.name}`, 'Khôi phục địa chỉ', {
        confirmButtonText: 'Khôi phục',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.resAddress()
      }).catch(() => {

      })
    },
    resAddress() {
      restoreAddress(this.address.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Khôi phục địa chỉ thành công'
          })
          this.reloadGsTable(this.addressTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Khôi phục địa chỉ thất bại'
          })
        }
      })
    },
    getDistricts() {
      this.filter.district_id = undefined
      this.filter()
      this.getDistrictByCityId({ city_id: this.filters.city_id, limit: -1, sort: 'name:1' })
    },
    getWards() {
      this.filter.ward_id = undefined
      this.filter()
      this.getWardByDistrictId({ district_id: this.filters.district_id, limit: -1, sort: 'name:1' })
    },
    selectClient(q) {
      if (q) {
        this.fetchClient = true
        getAllClients({ limit: 20, q: q }).then(response => {
          if (response.code === 200) {
            this.listClient = response.data
            this.fetchClient = false
          }
        })
      }
    },
    selectSuggettionClient() {
      this.setClient(this.suggettionClient)
      this.filters.client_id = this.suggettionClient.id
      this.filter()
    },
    removeClient() {
      this.filters.client_id = undefined
      this.filter()
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.addressTable]) {
      this.filters = ls.get('filters')[this.addressTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    if (!this.cities.length) {
      this.getAllCity({ limit: -1, sort: 'name:1' })
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.addressTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['addresses']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Address.vue?0861c951